import React, { createContext, useContext, useState } from 'react'

const PendingCompOffRequestContext = createContext();

export default function PendingCompOffRequestProvider({ children }) {
    const [pendingCompOffCount, setPendingCompOffCount] = useState(0);

    const updatePendingCompOffCount = (newCount) => {
    setPendingCompOffCount(newCount);
  };

  return (
    <PendingCompOffRequestContext.Provider value={{ pendingCompOffCount, updatePendingCompOffCount }}>
      {children}
    </PendingCompOffRequestContext.Provider>
  )
}

export const usePendingCompOffRequests = () => useContext(PendingCompOffRequestContext);